module.exports = " <div class=\"small-logo pointer-hover\" v-on:mouseover=mouseOver v-on:mouseleave=mouseLeave transition=logo _v-9a287e2e=\"\"> <canvas _v-9a287e2e=\"\"></canvas> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-9a287e2e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SmallLogo.vue
// module id = 772
// module chunks = 2